class AmazonReviews extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-amazon-reviews-track]');
    const prev = this.querySelector('[data-amazon-reviews-prev]');
    const next = this.querySelector('[data-amazon-reviews-next]');

    if (!this.track) return;

    this.hovered = false;

    const cardStep = () => {
      const card = this.track.querySelector('.amazon-reviews__card');
      return card ? card.offsetWidth + 14 : 300;
    };

    this.goNext = () => {
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (this.track.scrollLeft >= max - 5) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      }
    };

    if (prev) {
      prev.addEventListener('click', () => {
        this.restart();
        this.track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        this.restart();
        this.goNext();
      });
    }

    this.addEventListener('mouseenter', () => {
      this.hovered = true;
      this.pause();
    });

    this.addEventListener('mouseleave', () => {
      this.hovered = false;
      this.start();
    });

    this.start();
  }

  start() {
    this.pause();
    this.timer = setInterval(() => this.goNext(), 5000);
  }

  pause() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    if (!this.hovered) this.start();
  }
}

customElements.define('amazon-reviews', AmazonReviews);
